export default "__VITE_ASSET__9wW31cm$__"